/*
 * The spacing steps are named in stored descriptors, so the list lives in `@phis/contracts/layout` and
 * a token the server accepts is one this side can draw.
 */
export {
  PHI_SPACING_TOKENS,
  isPhiSpacingToken,
  type PhiSpacingToken,
} from "@phis/contracts/layout";
